export default __webpack_public_path__ + "static/media/phone_r.4cb2c089.png";